export const headerSection = {
  benefits: 'Переваги',
  partners: 'Партнери',
  setups: 'Налаштування',
};
export const description =
  'Сонце - наше головне джерело енергії та життя на Землі. Колись викопні види палива були створені з його енергії, але зараз ми використовуємо їх так швидко, що вони скоро закінчаться. Використання сонячної енергії - це перший крок до екологічної свідомості. І ми раді, що можемо супроводжувати вас на цьому шляху.';